import { APIs, API_BASE_URL, SERVICEURL } from "../constants/Constants";
import { _base64ToArrayBuffer } from "./StudyViewerService";
import axiosInterceptor from "../helpers/Interceptor";

export const downloadBillingReport = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.DOWNLOADBILL, body);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      const fileData = _base64ToArrayBuffer(response.data.data.data);
      const file = new Blob([fileData]);
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.data.data.filename);
      document.body.appendChild(link);
      link.click();
    }
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getHospitalList = async (body) => {
  try {
    const response = await axiosInterceptor.get(
      API_BASE_URL + APIs.GETBILLINGHOSPITALLIST
    );
    if (response.status === 200 && response.data.result === "SUCCESS") {
      return response.data.data.hospitalList;
    }
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
  return null;
};



export const initiateDownload = async (genericDTO) => {
  try {
    console.log("initiating downlod....");
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.BILLINGDATADOWNLOADEXCEL, 
      genericDTO
    );
    return response.data; // This should be the taskId
  } catch (error) {
    console.error("Error initiating download", error);
    return null;
  }
};

export const checkDownloadStatus = async (taskId) => {
  try {
    console.log("Checking download status....");
    const response = await axiosInterceptor.get(
      API_BASE_URL + SERVICEURL + `/api/download/billing/status/${taskId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error checking download status", error);
    return null;
  }
};

export const downloadBillingDataExcelSheet = async (genericDTO) => {
  try {
    const taskId = await initiateDownload(genericDTO);
    console.log('task id :'+taskId);
    if (!taskId) {
      throw new Error("Failed to initiate download");
    }

    let status = "IN_PROGRESS";
    while (status === "IN_PROGRESS") {
      await new Promise(resolve => setTimeout(resolve, 5000)); 
      status = await checkDownloadStatus(taskId);
      console.log('status :'+ status);
    }

    if (status === "COMPLETED") {
      console.log("status == COMPLETED");
      const response = await axiosInterceptor.get(
        API_BASE_URL + SERVICEURL + `/api/download/billing/result/${taskId}`, 
        { responseType: 'arraybuffer' }
      );

      const { fromDate, toDate, sheetType } = genericDTO.data;

      const randomNumber = Math.floor(100000 + Math.random() * 900000);
      const randomNumberString = randomNumber.toString();

      const filename = `${sheetType}_data_from_${fromDate}_to_${toDate}_${randomNumberString}.xlsx`;

      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error during form data sheet download", error);
  }
};

